// Journal de navigation produit, 100 % local (localStorage), transmis au RDV
// uniquement via le cookie mi_journey posé AU CLIC d'un CTA rendez-vous.
// Bornes (spec 2026-08-05) : 20 entrées, 7 jours, cookie ≤ 3000 caractères
// (et ≤ 3800 caractères encodés — marge sous la limite navigateur ~4096 octets,
// des noms riches en accents pouvant gonfler fortement une fois encodés).
const STORAGE_KEY = 'mi_browse_journal';
const MAX_ENTRIES = 20;
const MAX_AGE_MS = 7 * 24 * 3600 * 1000;
const COOKIE_MAX_CHARS = 3000;
const COOKIE_MAX_ENCODED_CHARS = 3800;

export function readJournal(now = Date.now()) {
  let raw;
  try {
    raw = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch {
    raw = [];
  }
  if (!Array.isArray(raw)) raw = [];
  return raw.filter((e) => e && typeof e.at === 'number' && now - e.at <= MAX_AGE_MS);
}

function write(journal) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(journal.slice(-MAX_ENTRIES)));
  } catch {
    /* stockage plein/bloqué : le journal est un bonus, jamais bloquant */
  }
}

export function recordProductView(product, now = Date.now()) {
  if (!product?.id || !product?.name) return;
  const journal = readJournal(now);
  const last = journal[journal.length - 1];
  if (last && last.id === product.id) {
    last.at = now;
  } else {
    if (last && last.s === undefined) {
      last.s = Math.max(1, Math.round((now - last.at) / 1000));
    }
    journal.push({
      id: product.id,
      n: String(product.name).slice(0, 60),
      p: typeof product.price === 'number' ? product.price : undefined,
      at: now,
    });
  }
  write(journal);
}

export function buildJourneyCookieValue(journal) {
  let entries = journal.map(({ n, p, at, s }) => ({ n, p, at, s }));
  let value = JSON.stringify(entries);
  while (
    (value.length > COOKIE_MAX_CHARS || encodeURIComponent(value).length > COOKIE_MAX_ENCODED_CHARS) &&
    entries.length > 1
  ) {
    entries = entries.slice(1); // on sacrifie les plus anciennes
    value = JSON.stringify(entries);
  }
  return entries.length ? value : '';
}

export function writeJourneyCookie(now = Date.now()) {
  const value = buildJourneyCookieValue(readJournal(now));
  if (!value) return;
  document.cookie =
    `mi_journey=${encodeURIComponent(value)}; Domain=.meteris.fr; ` +
    'Path=/; Max-Age=3600; SameSite=Lax; Secure';
}
